import rootStore from '@/store';
import { reportingService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default class ReportingCallLogsGridService {
  constructor() {
    this.gridCallback = () => [];
  }

  validateCurrentSettings() {
    return !!rootStore.getters['reporting/activeCallLogTranslatedTimeZoneId'];
  }

  getRows({ request, successCallback, failCallback, parentNode }) {
    // Notes
    // - Call logs API should return all columns values by default
    // - There will be no row group columns or value columns
    if (!this.validateCurrentSettings()) {
      return successCallback([], 0);
    }
    
    let { apiRequestData } = this.getApiRequestData(request, parentNode.columnApi);

    return reportingService.getCallLogs(rootStore.state.currentAccountId, apiRequestData).then(({ callLogs, totalCount }) => {
      successCallback(callLogs, totalCount);
      this.gridCallback(callLogs, totalCount);
    }).catch(failCallback);
  }

  setGridCallback(callback) {
    this.gridCallback = callback;
  }

  getApiRequestData(request, gridColumnApi) {
    const { reportStart, reportEnd } = reportingService.getReportingDateRange(
      rootStore.getters['reporting/activeCallLogTimeRange'],
      rootStore.getters['reporting/activeCallLogTranslatedTimeZoneId']
    );

    const filters = [
      ...reportingService.getFilterFromFilterCriteria(rootStore.getters['reporting/activeCallLogFilterCriteria'])
    ];

    return {
      apiRequestData: {
        reportStart,
        reportEnd,
        orderByColumns: request.sortModel.map(sort => (
          { column: sort.colId, direction: sort.sort }
        )),
        filters,
        valueColumns: gridColumnApi.getAllColumns()
          .filter(c => c.colId !== 'action'
            && (c.userProvidedColDef.ringbaGroupName !== 'Tags'
            || (c.userProvidedColDef.ringbaGroupName === 'Tags' && c.visible)
            ))
          .map(c => {
            return {
              column: c.colId
            };
          }),
        formatTimespans: true,
        formatPercentages: true,
        formatDateTime: true,
        formatTimeZone: rootStore.getters['reporting/activeCallLogTranslatedTimeZoneId'],
        size: request.endRow - request.startRow,
        offset: request.startRow,
        viewAsPubId: rootStore.getters['reporting/activeCallLogViewAsPubId'],
        viewAsBuyerId: rootStore.getters['reporting/activeCallLogViewAsBuyerId'],
        viewAsManagerId: rootStore.getters['reporting/activeCallLogViewAsManagerId'],
      },
    };
  }

}